import { SelectButton } from '@components/SelectButton'
import { SelectButtonFieldProps } from './interface'

export default function SelectButtonField(props: SelectButtonFieldProps) {
  return <SelectButton {...props} />
}
